module.exports = __webpack_public_path__ + "img/prize0_active.6177c8b.png";